<div class="rak-lang-switch" [class.is-ar]="lang === 'ar'" role="group" aria-label="Language">

  <span *ngIf="lang === 'en'; else enLink"
        class="rak-lang-switch-option is-active"
        lang="en"
        aria-current="true">EN</span>
  <ng-template #enLink>
    <a class="rak-lang-switch-option" [routerLink]="enUrl" lang="en">EN</a>
  </ng-template>

  <span *ngIf="lang === 'ar'; else arLink"
        class="rak-lang-switch-option is-active"
        lang="ar"
        aria-current="true">عربي</span>
  <ng-template #arLink>
    <a class="rak-lang-switch-option" [routerLink]="arUrl" lang="ar">عربي</a>
  </ng-template>

</div>
